(() => {
  if (window.CFACartRewards) return;
  const thresholds = [20000, 25000, 75000, 100000];
  function calculate(state) {
    const spend = Math.max(0, Number(state.spend) || 0);
    const rate = spend >= 100000 ? 10 : spend >= 75000 ? 5 : spend >= 25000 ? 2.5 : 0;
    const shippingEligible = !!state.hasShipping && !state.shippingExcluded;
    const freeShipping = shippingEligible && spend >= 20000;
    const next = thresholds.find(value => value > spend && (value !== 20000 || shippingEligible));
    return { spend, rate, next, freeShipping, shippingEligible, remaining: next ? next - spend : 0, progress: Math.min(100, spend / 1000) };
  }
  window.CFACartRewards = { calculate };
  if (typeof document === 'undefined') return;
  let state, requestNumber = 0, controller;
  const stateContainer = () => document.querySelector('[data-rewards-state-container]');
  const money = cents => new Intl.NumberFormat('en-AU', {style:'currency', currency:'AUD', maximumFractionDigits: cents % 100 ? 2 : 0}).format(cents / 100);
  function render(widget) {
    if (!state) return;
    widget.hidden = !(state.enabled || state.preview) || !state.itemCount || state.currency !== 'AUD' || state.spend <= 0;
    if (widget.hidden) return;
    const result = calculate(state);
    if (widget.hasAttribute('data-cart-compact')) {
      widget.querySelector('[data-rewards-message]').textContent = state.saving > 0
        ? `Cart reward: ${money(state.saving)} saved`
        : 'Automatic cart rewards · View tiers';
      return;
    }
    const nextLabel = result.next === 20000 ? 'unlock free standard shipping' : `unlock ${result.next === 25000 ? '2.5' : result.next === 75000 ? '5' : '10'}% off`;
    let message = result.next ? `Add ${money(result.remaining)} to ${nextLabel}.` : 'Maximum reward tier reached: 10% off.';
    if (result.freeShipping) message = `${result.rate ? result.rate + '% off + free standard shipping unlocked.' : 'Free standard shipping unlocked.'} ${result.next ? `Add ${money(result.remaining)} to ${nextLabel}.` : 'Your highest cart reward is unlocked.'}`;
    else if (result.rate && result.next) message = `${result.rate}% tier reached. ${message}`;
    if (state.preview && !state.enabled) message = `Preview · ${message}`;
    widget.querySelector('[data-rewards-message]').textContent = message;
    widget.querySelector('[data-rewards-fill]').style.width = `${result.progress}%`;
    const progress = widget.querySelector('[role="progressbar"]');
    progress.setAttribute('aria-valuenow', Math.min(1000, result.spend / 100));
    progress.setAttribute('aria-valuetext', `${money(result.spend)} qualifying spend. ${message}`);
    widget.querySelectorAll('[data-threshold]').forEach(node => node.classList.toggle('is-reached', result.spend >= Number(node.dataset.threshold) && (Number(node.dataset.threshold) !== 20000 || result.shippingEligible)));
    const saving = widget.querySelector('[data-rewards-saving]');
    saving.hidden = !state.saving;
    saving.textContent = `Cart reward applied: −${money(state.saving)}`;
    widget.querySelector('[data-rewards-shipping]').textContent = !state.hasShipping ? 'Delivery is not required for these items.' : state.shippingExcluded ? 'This cart includes bags, other excluded items or excess weight. Free shipping does not apply; delivery charges are shown at checkout.' : result.freeShipping ? 'Free standard shipping applies to eligible Australian delivery. Express remains $20. Final eligibility is confirmed at checkout.' : 'Free standard shipping on eligible Australian orders $200+. Otherwise standard is $15; express is $20.';
  }
  function renderShippingSummary(summary) {
    const ready = state && state.enabled && state.itemCount && state.currency === 'AUD' && state.hasShipping;
    summary.querySelector('[data-shipping-fallback]').hidden = !!ready;
    summary.querySelector('[data-shipping-rates]').hidden = !ready;
    if (!ready) return;
    const result = calculate(state);
    summary.querySelector('[data-standard-price]').textContent = result.freeShipping ? 'Free' : '$15';
    summary.querySelector('[data-shipping-eligibility]').textContent = state.shippingExcluded
      ? 'Free shipping excludes this cart: bags, other freight exclusions or 10 kg+.'
      : result.freeShipping
        ? 'Free standard shipping applied to eligible Australian orders $200+.'
        : `Add ${money(Math.max(0, 20000 - result.spend))} in eligible products for free standard shipping ($200+).`;
  }
  function renderAll() {
    document.querySelectorAll('cfa-cart-rewards').forEach(render);
    document.querySelectorAll('[data-cart-shipping-summary]').forEach(renderShippingSummary);
  }
  function readState(root = document) {
    const script = root.querySelector('[data-rewards-state]');
    if (!script) throw new Error('Cart rewards state missing');
    state = JSON.parse(script.textContent); renderAll();
  }
  async function refresh() {
    const current = ++requestNumber; controller?.abort(); controller = new AbortController();
    state = undefined; renderAll();
    const container = stateContainer(); if (!container) return;
    document.querySelectorAll('cfa-cart-rewards').forEach(node => { node.hidden = true; });
    try {
      const url = new URL(container.dataset.root, location.origin); url.searchParams.set('section_id', container.dataset.sectionId);
      const response = await fetch(url, {signal:controller.signal, cache:'no-store'});
      if (!response.ok) throw new Error('Cart refresh failed');
      const html = await response.text(); if (current !== requestNumber) return;
      readState(new DOMParser().parseFromString(html, 'text/html'));
    } catch (error) { if (error.name !== 'AbortError') document.querySelectorAll('cfa-cart-rewards').forEach(node => { node.hidden = true; }); }
  }
  class Rewards extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-cart-compact')) { render(this); return; }
      this.abort?.abort(); this.abort = new AbortController();
      const toggle = this.querySelector('[data-rewards-toggle]');
      let collapsed = !!this.closest('cart-drawer') || this.hasAttribute('data-compact');
      try { if (this.hasAttribute('data-floating')) collapsed = sessionStorage.getItem('cfa-rewards-collapsed') === 'true'; } catch (_) {}
      const setCollapsed = value => { this.querySelector('[data-rewards-details]').hidden = value; toggle.textContent = value ? 'Show details' : 'Hide details'; toggle.setAttribute('aria-expanded', String(!value)); };
      setCollapsed(collapsed);
      toggle.addEventListener('click', () => { collapsed = !collapsed; setCollapsed(collapsed); if (this.hasAttribute('data-floating')) try {sessionStorage.setItem('cfa-rewards-collapsed', String(collapsed));} catch (_) {} }, {signal:this.abort.signal});
      render(this);
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('cfa-cart-rewards', Rewards);
  try { readState(); } catch (_) { refresh(); }
  document.addEventListener('cart:prepare-bundled-sections', event => { const id = stateContainer()?.dataset.sectionId; if (id && event.detail.sections.length < 5 && !event.detail.sections.includes(id)) event.detail.sections.push(id); });
  document.addEventListener('cart:change', event => {
    ++requestNumber; controller?.abort();
    const id = stateContainer()?.dataset.sectionId, html = event.detail?.cart?.sections?.[id];
    if (html) { try {readState(new DOMParser().parseFromString(html, 'text/html'));} catch (_) {refresh();} } else refresh();
  });
  document.addEventListener('cart-drawer:refreshed', renderAll);
  document.addEventListener('cart:refresh', refresh);
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  const updateObscured = () => { const floating = document.querySelector('cfa-cart-rewards[data-floating]'); if (floating) floating.toggleAttribute('data-obscured', !!document.querySelector('cart-drawer[open], quick-buy-drawer[open], .product-sticky-bar.is-visible')); };
  new MutationObserver(updateObscured).observe(document.body, {subtree:true, attributes:true, attributeFilter:['open','class']});
  updateObscured();
})();

// Set a shipping-first preference on the existing cart before normal checkout.
// Shopify otherwise remembers Pickup when a customer reopens the same checkout.
(() => {
  if (window.cfaShippingFirstCheckout) return;
  window.cfaShippingFirstCheckout = true;
  const pending = new WeakSet();
  const resuming = new WeakSet();
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (!(form instanceof HTMLFormElement)) return;
    if (resuming.has(form)) { resuming.delete(form); return; }
    const action = new URL(form.action, location.href);
    const checkout = button?.name === 'checkout' || /\/checkout\/?$/.test(action.pathname);
    if (!checkout || action.origin !== location.origin) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending.has(form)) return;
    pending.add(form);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 2500);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!cart.token || !cart.item_count) throw new Error('No cart');
      const result = await fetch('/api/2026-10/graphql.json', {
        method: 'POST', credentials: 'same-origin', signal: controller.signal,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          query: 'mutation ShippingFirst($id:ID!){cartBuyerIdentityUpdate(cartId:$id,buyerIdentity:{preferences:{delivery:{deliveryMethod:[SHIPPING],pickupHandle:[]}}}){userErrors{message}}}',
          variables: { id: 'gid://shopify/Cart/' + cart.token }
        })
      });
      if (!result.ok) throw new Error('Preference unavailable');
      await result.json();
    } catch (_) {
      // Continue native checkout if Shopify is unavailable; never block purchase.
    } finally {
      clearTimeout(timeout);
      pending.delete(form);
      resuming.add(form);
      if (button && button.form === form) form.requestSubmit(button);
      else form.requestSubmit();
    }
  }, true);
})();
